import styled, { css, useTheme } from "styled-components";
import { CircleCheck } from "lucide-react";
import { hexToRGB } from "@shared/utils/misc";
import { newLookPanel } from "features/settings/CancelSubscription/styles.tsx";
import {
  Description,
  Title,
} from "features/settings/CancelSubscription/styles.tsx";
import React from "react";
import { getUserExpirationInfo } from "@shared/utils/misc.ts";
import { useUser } from "@shared/utils/hooks/misc.ts";
import LinkButton from "common/Buttons/LinkButton.tsx";
import { useHistory } from "react-router-dom";
import { BILLING_SETTINGS_PATH } from "common/constants.ts";
import {
  SuccessMainIcon,
  SuccessMainIconDark,
} from "features/settings/CancelSubscription/icons.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

const Success = () => {
  const history = useHistory();
  const { user } = useUser();
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const formattedExpiration = getUserExpirationInfo(user, t)[1];
  const theme = useTheme();
  const { isDarkMode, isNewLook } = theme;

  const Icon = isDarkMode ? SuccessMainIconDark : SuccessMainIcon;

  return (
    <Wrapper>
      {isNewLook ? (
        <StatusIcon $color={theme.colors.green}>
          <CircleCheck size={28} strokeWidth={1.75} />
        </StatusIcon>
      ) : (
        <Icon $size="240px" style={{ marginBottom: 20 }} />
      )}
      <Title>{t("success.auto_renewal_canceled")}</Title>
      <Description style={{ marginBottom: 0 }}>
        {t("success.subscription_active")}{" "}
        <Description
          as="span"
          style={{ marginBottom: 0, display: "inline", whiteSpace: "nowrap" }}
          $weight={600}
        >
          {formattedExpiration}
        </Description>
        .
      </Description>
      <Description style={{ marginBottom: 16 }}>
        {t("success.reactivate_auto_renewal")}
      </Description>
      <LinkButton
        type="link"
        onClick={() => history.push(BILLING_SETTINGS_PATH)}
      >
        {t("success.done")}
      </LinkButton>
    </Wrapper>
  );
};

export default Success;

const StatusIcon = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  /* The 8px halo is drawn outside the box: 32px from the card top to the
     halo, 20px from the halo to the title. */
  margin: 8px auto 28px;
  border-radius: 50%;
  color: ${(p) => p.$color};
  background: ${(p) => hexToRGB(p.$color, 0.12)};
  box-shadow: 0 0 0 8px ${(p) => hexToRGB(p.$color, 0.06)};
`;
const Wrapper = styled.div`
  margin-top: 16px;
  text-align: center;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      ${newLookPanel}
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 32px;
      padding-bottom: 32px;
      && > :last-child {
        margin-bottom: 0;
      }
    `}
`;
